import React from 'react';
import PropTypes from 'prop-types';
import AuthRoute from './authRoute';
import useAppContext from '../context/useAppContext';
import PageError from '../pages/error/pageError';

export default function AuthRouteModeration({ allow = [], path = '', fallback = null, children = null, isAdmin = true, ...routeProps }) {
    const [{ organization }] = useAppContext();

    const backHomeUrl = React.useMemo(() => {
        if (!organization) {
            return null;
        }

        return `/ticket/O${organization.id}/moderation`;
    }, [organization]);

    return (
        <AuthRoute allow={allow} path={path} isAdmin={isAdmin} fallback={fallback || <PageError errorCode={403} backHomeUrl={backHomeUrl} />} {...routeProps}>
            {children}
        </AuthRoute>
    );
}

AuthRouteModeration.propTypes = {
    allow: PropTypes.array,
    path: PropTypes.string,
    children: PropTypes.node,
    fallback: PropTypes.node,
    isAdmin: PropTypes.bool
};
